import { render, staticRenderFns } from "./DomainResults.vue?vue&type=template&id=1a93a9ad&"
import script from "./DomainResults.vue?vue&type=script&lang=js&"
export * from "./DomainResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports